import { createSlice } from '@reduxjs/toolkit';

import { status } from 'utils/const';
import { thunks } from './thunks';
import { selectors } from './selectors';

const defaultValues = {
  dateFrom: null,
  dateTo: null,
  amountFrom: null,
  amountTo: null,
  status: { label: '', value: '' },
};

const initialState = {
  invoicesList: [],
  invoice: {},
  invoiceSchedules: [],
  filters: {
    fields: defaultValues,
    updatedFields: 0,
  },
  pagination: {
    current: 1,
    total: 0,
  },
  sort: {
    sortDirection: 'desc',
    sortBy: 'invoiceDate',
  },

  loadingListStatus: status.IDLE,
  loadingInvoice: status.IDLE,
  loadingInvoiceSchedules: status.IDLE,
};

const slice = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
    setFilters: (state, { payload }) => {
      let updatedFieldsCount = 0;
      const defaultValues = Object.values(initialState.filters.fields);

      Object.values(payload).forEach((field, index) => {
        if (field !== defaultValues[index]) {
          updatedFieldsCount += 1;
        }
      });

      state.filters.updatedFields = updatedFieldsCount;
      state.filters.fields = payload;
    },
    setPage: (state, { payload }) => {
      state.pagination.current = payload;
    },
    setSort: (state, { payload }) => {
      state.sort = payload;
    },
    clearInvoice: (state) => {
      state.invoice = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(thunks.getInvoicesList.pending, (state) => {
        state.loadingListStatus = status.PENDING;
      })
      .addCase(thunks.getInvoicesList.fulfilled, (state, action) => {
        state.invoicesList = action.payload.data;
        state.pagination.total = action.payload.meta.total;
        state.loadingListStatus = status.SUCCESS;
      })
      .addCase(thunks.getInvoicesList.rejected, (state) => {
        state.loadingListStatus = status.FAIL;
      })
      .addCase(thunks.getUserInvoice.pending, (state) => {
        state.loadingInvoice = status.PENDING;
      })
      .addCase(thunks.getUserInvoice.fulfilled, (state, action) => {
        state.invoice = action.payload.data;
        state.loadingInvoice = status.SUCCESS;
      })
      .addCase(thunks.getUserInvoice.rejected, (state) => {
        state.loadingInvoice = status.FAIL;
      })
      .addCase(thunks.getUserInvoiceSchedules.pending, (state) => {
        state.loadingInvoiceSchedules = status.PENDING;
      })
      .addCase(thunks.getUserInvoiceSchedules.fulfilled, (state, action) => {
        state.invoiceSchedules = action.payload.data;
        state.loadingInvoiceSchedules = status.SUCCESS;
      })
      .addCase(thunks.getUserInvoiceSchedules.rejected, (state) => {
        state.loadingInvoiceSchedules = status.FAIL;
      });
  },
});

const invoices = {
  actions: slice.actions,
  thunks,
  selectors,
};

export { invoices };
export default slice.reducer;
